import Image from '@components/image'
import AuthBannerImage from './auth-banner.png'
import { StyleAuthBannerWrapper } from './style'
const AuthBanner = () => {
  return (
    <StyleAuthBannerWrapper>
      <Image src={AuthBannerImage} alt="auth banner" styleImage="width:70%;" />
    </StyleAuthBannerWrapper>
  )
}

export default AuthBanner
